(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  function pick(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.cart-upsell__add[data-variant-id]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var variantId = btn.getAttribute('data-variant-id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.status) {
          btn.classList.remove('is-loading');
          return;
        }
        var sections = data.sections || {};
        if (sections['cart-drawer']) {
          var newInner = pick(sections['cart-drawer'], '.drawer__inner');
          var curInner = document.querySelector('#CartDrawer .drawer__inner');
          if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
        }
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var newBubble = pick(sections['cart-icon-bubble'], '.shopify-section');
          if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
          else if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.remove('is-empty');
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
        }
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });
})();

/* Rewards milestone celebration: flash a message for 3s when a new tier is crossed. */
(function () {
  if (window.__cartRewardsInit) return;
  window.__cartRewardsInit = true;

  var DURATION = 3000;

  function getBar() { return document.querySelector('#CartDrawer .cart-rewards'); }

  function check() {
    var bar = getBar();
    if (!bar) { window.__cartRewardsPrev = undefined; return; }
    var count = parseInt(bar.getAttribute('data-achieved') || '0', 10);
    var prev = window.__cartRewardsPrev;
    if (typeof prev === 'number' && count > prev) {
      bar.classList.add('cart-rewards--celebrating');
      clearTimeout(window.__cartRewardsTimer);
      window.__cartRewardsTimer = setTimeout(function () {
        var b = getBar();
        if (b) b.classList.remove('cart-rewards--celebrating');
      }, DURATION);
    }
    window.__cartRewardsPrev = count;
  }

  function start() {
    var root = document.getElementById('CartDrawer');
    if (!root) { setTimeout(start, 600); return; }
    new MutationObserver(function () { check(); }).observe(root, { childList: true, subtree: true });
    check();
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
